import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const UseHubName = (hubId) => {
  const [hubName, setHubName] = useState(null);

  useEffect(() => {
    if (!hubId) return; // Evita ejecuciones sin hubId

    const fetchHubName = async () => {
      try {
        const hubRef = doc(db, 'private-hubs', hubId);
        const hubSnap = await getDoc(hubRef);
        if (hubSnap.exists()) {
          setHubName(hubSnap.data().Nombre);
        } else {
          setHubName('Hub no encontrado');
        }
      } catch (error) {
        console.error('Error al obtener el nombre del hub:', error);
        setHubName('Error al cargar datos');
      }
    };

    fetchHubName();
  }, [hubId]);

  return hubName;
};

const GetHubInfo = (hubId) => {
  const [hubInfo, setHubInfo] = useState([]);

  useEffect(() => {
    if (!hubId) return; // Evita ejecuciones sin hubId

    const fetchHubName = async () => {
      try {
        const hubRef = doc(db, 'private-hubs', hubId);
        const hubSnap = await getDoc(hubRef);
        if (hubSnap.exists()) {
          setHubInfo(hubSnap.data());
        } else {
          setHubInfo('Hub no encontrado');
        }
      } catch (error) {
        console.error('Error al obtener la info hub:', error);
        setHubInfo('Error al cargar datos');
      }
    };

    fetchHubName();
  }, [hubId]);

  return hubInfo;
};


export {UseHubName, GetHubInfo};
